<template>
  <card title="Preview" has-icon class="full-height">
    <template #icon>
      <span class="slds-icon_container slds-icon-standard-metrics">
        <svg class="slds-icon slds-icon-action-log-this-metrics" aria-hidden="true">
          <use xlink:href="../../assets/symbols.svg#metrics" />
        </svg>
      </span>
    </template>
    <template #actions>
      <button class="slds-button slds-button_neutral" @click="$emit('newPreview')" v-if="checkPermission('MANAGE_FAST_COUNTER')">
        {{$t('action.new')}}
      </button>
    </template>
    <div class="slds-form-element" v-if="list.length">
      <SLDSInput
        :label="$t('fastCounter.targetDefinition.filterPreviews')"
        :placeholder="$t('action.filter')"
        class="slds-m-bottom--small"
        has-left-icon
        type="text"
        v-model="localSearchKey"
        @keyup-enter="filterPreviews">
          <use xlink:href="../../assets/symbols.svg#search" slot="leftIcon"></use>
      </SLDSInput>
    </div>
    <p v-if="!filteredPreviews.length">No results</p>
    <preview-table class="slds-m-top--medium" :list="filteredPreviews" @update="loadList" />
  </card>
</template>
<script>
import { mapActions } from 'vuex'
import Card from '../../components/slds/Card'
import CheckPermission from '../../components/utils/CheckPermission'
import PreviewFilters from './PreviewFilters'
import PreviewTable from './PreviewTable'
import SLDSInput from '../../components/slds/Input'
import { applyFiltersToList } from '../../components/utils/utils'

export default {
  mixins: [CheckPermission],
  components: {
    Card,
    PreviewFilters,
    PreviewTable,
    SLDSInput
  },
  data () {
    return {
      filteredPreviews:[],
      list: [],
      localSearchKey: ''
    }
  },
  created () {
    this.loadList()
  },
  methods: {
    applyFilters: _.debounce((list, searchKey, filtersObject, fieldsToFilter, sortingOptions, callback) => applyFiltersToList(list, searchKey, filtersObject, fieldsToFilter, sortingOptions, callback), 300),
    filterPreviews(){
      this.applyFilters(this.list, this.localSearchKey, {}, ['name'], null, (result) => { this.filteredPreviews = result })
    },
    async loadList(){
      try {
        this.list = await this.getPreviewList()
        this.filteredPreviews = this.list
      } catch (error) {
        console.error(error)
      }
    },
    ...mapActions(
      {
        getPreviewList: 'fastCounter/getPreviews'
      }
    )
  }
}
</script>
<style scoped>
  .full-height {
    height: 100%;
  }
</style>
